var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTravelAgent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Plane-Check-In--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Plane Check In Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 3.25a3 3 0 1 0 6 0 3 3 0 1 0 -6 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.75a2 2 0 0 0 -2 -2h-0.4a0.51 0.51 0 0 0 -0.42 0.22l-0.76 1.16a0.51 0.51 0 0 1 -0.84 0L10.82 8a0.51 0.51 0 0 0 -0.42 -0.22H10a2 2 0 0 0 -2 2v1a0.5 0.5 0 0 0 0.5 0.5h7a0.5 0.5 0 0 0 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.25H2.29a2.53 2.53 0 0 0 -1.79 2.5v8.5a0.5 0.5 0 0 0 0.5 0.5h22a0.5 0.5 0 0 0 0.5 -0.5v-8.5a2.5 2.5 0 0 0 -2.5 -2.5Zm-4.91 5.46 -6 3.71a0.35 0.35 0 0 1 -0.4 0l-2.17 -1.55a0.2 0.2 0 0 1 0 -0.28l1 -0.85a0.21 0.21 0 0 1 0.19 0l0.88 0.53a0.5 0.5 0 0 0 0.54 0l0.88 -0.62a0.26 0.26 0 0 0 0.11 -0.21 0.27 0.27 0 0 0 -0.12 -0.21l-3 -1.85a0.37 0.37 0 0 1 -0.18 -0.26 0.44 0.44 0 0 1 0.09 -0.31l0.28 -0.33a0.29 0.29 0 0 1 0.29 -0.08L13 17.07a0.5 0.5 0 0 0 0.46 -0.05L15 16a1 1 0 0 1 0.77 -0.15 1 1 0 0 1 0.75 0.68 1 1 0 0 1 0.06 0.33 1 1 0 0 1 -0.49 0.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTravelAgent);
export default ForwardRef;